import React from 'react'
import { creationEventStore } from 'state/event/eventCreationStore'
import { EventResp } from 'types/event/events'
import SelectDatesCalendar from 'components/global/SelectDatesCalendar'
import { RecepientToSend } from 'types/event/eventStep5'
import { leagueEventStore } from 'state/league/leagueEvent'
import { creationClassStore } from 'state/class/classCreationStore'

interface DateRecepientProps {
  recepientPayload: RecepientToSend
  setRecepientPayload: React.Dispatch<React.SetStateAction<RecepientToSend>>
  reference?: 'event' | 'league' | 'organization' | 'class'
}

const DateRecepient: React.FC<DateRecepientProps> = ({
  recepientPayload,
  setRecepientPayload,
  reference,
}) => {
  const { eventData }: { eventData: EventResp } = creationEventStore(store => ({
    eventData: store.eventData,
  }))
  const { leagueData } = leagueEventStore(store => ({
    leagueData: store.leagueData,
  }))

     const { classData } = creationClassStore (store => ({
    classData: store.classData,
  }))

  const handleDateChange = (dates: string[]) => {
    setRecepientPayload({
      ...recepientPayload,
      eventDates: dates,
    })
  }

  return (
    <div className="h-13 scroller overflow-auto-y">
      <div className="mt-20px mx-auto" style={{ width: '360px' }}>
        <SelectDatesCalendar
          isLimited={true}
          selectedDates={recepientPayload?.eventDates || []}
          setSelectedDates={handleDateChange}
          occurrenceDates={
            reference === 'league' ? leagueData.datesOfEvent :
            reference === 'event' ? eventData.datesOfEvent :
            reference === 'class' ? classData.datesOfEvent :
            []
          }
        />
      </div>
    </div>
  )
}

export default DateRecepient
